import { Stack, Typography } from '@mui/material';

type Props = {
    icon: React.ReactNode;
    header: React.ReactNode;
    headerOthers?: React.ReactNode;
    /** Theme spacing units between icon and title. Default 2 (matches historical layout). */
    iconColumnGap?: number;
};

const PageHeader = ({ icon, header, headerOthers, iconColumnGap = 2 }: Props) => (
    <Stack direction="row" alignItems="start" columnGap={iconColumnGap} width="100%">
        <Typography
            variant="h4"
            color="primary.main"
            sx={{ mt: 0.5, display: 'inline-flex', alignItems: 'center', lineHeight: 1 }}
        >
            {icon}
        </Typography>
        {typeof header === 'string' ? (
            <Typography color="primary.main" variant="h4" whiteSpace="nowrap">
                {header}
            </Typography>
        ) : (
            header
        )}
        {headerOthers && (
            <Stack direction="row" alignSelf="center" width="100%">
                {headerOthers}
            </Stack>
        )}
    </Stack>
);

export default PageHeader;
